import CrudGrid from '~/common/components/CrudGrid';
import type { GridDef } from '~/common/components/CrudGrid/GridDef';
import useIsWriteAccessDisabled from '~/common/hooks/useIsWriteAccessDisabled';

import { useBorrower1003Store } from '../borrower1003Store';
import { use1003BorrowerData, useDeleteBorrower1003Mutation } from '../hooks';

const gridDef: GridDef = {
  defaultSort: { field: 'balance', direction: 'desc' },
  uniqueIdAttributeFields: ['customerRecordId'],
  allowFilters: false,
  gridLanguage: {
    singularItem: 'Borrower',
    pluralItem: 'Borrowers',
  },
  getDialogDeleteMessage: (rows) =>
    `Are you sure you want to delete the following Borrower: ${rows
      .map((r) => `${r.firstName} ${r.lastName}`)
      .join(', ')}?`,
};

type BorrowerColumn = {
  fieldName: string;
  headerName: string;
  isNumeric?: boolean;
  renderCell?: (val: any) => React.ReactNode;
};

const columns: BorrowerColumn[] = [
  {
    fieldName: 'firstName',
    headerName: 'First Name',
  },
  {
    fieldName: 'middleName',
    headerName: 'Middle Name',
  },
  {
    fieldName: 'lastName',
    headerName: 'Last Name',
  },
  {
    fieldName: 'suffixName',
    headerName: 'Suffix',
  },
  {
    fieldName: 'socialSecurityNumber',
    headerName: 'Social Security Number',

    renderCell: (val: string) => {
      if (!val) return '-';

      return `xxx-xx-${val.slice(-4)}`;
    },
  },
  {
    fieldName: 'borrowerPosition',
    headerName: 'Position',

    renderCell: (val: number) => (val === 1 ? '1 (Primary)' : val),
  },
];

export function BorrowerCrudGrid() {
  const { isLoading, data } = use1003BorrowerData();
  const { mutate: deleteBorrower } = useDeleteBorrower1003Mutation();

  const isWriteAccessDisabled = useIsWriteAccessDisabled();

  const { selectedBorrowerId, setSelectedBorrowerId } = useBorrower1003Store();

  return (
    <CrudGrid
      gridDef={gridDef}
      columns={columns}
      data={data?.borrowers ?? []}
      dropdownOptions={data?.dropdownOptions ?? []}
      onRowEditClick={(row) => {
        setSelectedBorrowerId(row.customerRecordId);
      }}
      readOnly={isWriteAccessDisabled}
      selectedRow={
        selectedBorrowerId ? { customerRecordId: selectedBorrowerId } : null
      }
      isLoading={isLoading}
      onDelete={(rows) => deleteBorrower(rows)}
      disableRowDelete={data?.isDeleteRowDisabled}
      onGridModeChange={() => {
        setSelectedBorrowerId(null);
      }}
      isAuditHistoryEnabled={data?.isAuditHistoryEnabled}
    />
  );
}
